import React from "react";

const MinhaEmpresaPage = () => {
    return <div>MinhaEmpresa</div>
}

export default MinhaEmpresaPage;